import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({endPoint: `Dilucion/comprobarPrimeraDilucionDelDia`, method: 'GET'})
}
